import { app } from '../../../app';

app.constant('url', 'app/rest/applicationNonBlocked/:id');


app.factory('ApplicationService', ApplicationService);

/** @ngInject */
function ApplicationService($resource, url) {

var url2='app/rest/customappsForRegisteration';
    return $resource(url, {}, {
        'findAll': {
            method: 'GET',
            isArray: true,
        },
		'findAllToRegister' :{
			method: 'GET',
			url: url2,
			isArray:true
		},
		'registerAccount' :{
			url: 'app/rest/registerOnCustomApp/:appid',
			method:'POST',
			params:{
				appid: '@appid'
			}
		},
		'changePassOnCustomApp' : {
			url: 'app/rest/updatePassword/',
			method: 'POST'
					
		}
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/applications.service.js